import React from 'react';
import { Text, Link } from '@gravity-ui/uikit';

import { cardHeaderLinkWrapCn, cardHeaderTitleCn, cnCard } from './Card.const';
import type { ICardProps } from './Card.typings';

import './Card.scss';

export const Card: React.FC<ICardProps> = props => {

    const onClick = React.useCallback<React.MouseEventHandler<HTMLDivElement>>(() => {
        if ('onClick' in props && props.onClick !== undefined) {
            props.onClick();
        }
    }, [
        'onClick' in props ? props.onClick : undefined,
        'link' in props ? props.link : undefined,
    ]);

    return (
        <div className={cnCard(null, [props.className])} onClick={onClick}>
            {props.headerTitle !== undefined && (
                <div className={cnCard('Header', [props.headerClassName])}>
                    <Text variant="subheader-3" className={cardHeaderTitleCn}>
                        {props.headerTitle}
                    </Text>
                    {' '}
                    {props.headerLink && (
                        <Text variant="subheader-1" className={cardHeaderLinkWrapCn}>
                            <Link {...props.headerLink} className={cnCard('HeaderLink', [props.headerLink.className])} />
                        </Text>
                    )}
                </div>
            )}
            <div className={cnCard('Content', [props.contentClassName])}>
                {props.children}
            </div>
        </div>
    );
};
